module.exports = __webpack_public_path__ + "img/a3.5422567a.jpg";